import { render } from "./AdminImages.vue?vue&type=template&id=0a3427b1&scoped=true"
import script from "./AdminImages.vue?vue&type=script&lang=js"
export * from "./AdminImages.vue?vue&type=script&lang=js"

import "./AdminImages.vue?vue&type=style&index=0&id=0a3427b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3427b1"]])

export default __exports__